<div
  *ngIf="loader; else elseBlock"
  class="loader-container"
  role="status"
  aria-live="polite"
>
  <div class="loader-card">
    <mat-progress-spinner
      class="brand-spinner"
      mode="indeterminate"
      [diameter]="88"
      [strokeWidth]="8"
    ></mat-progress-spinner>

    <div class="loader-text">
      <p class="loader-title">Cargando información</p>
      <p class="loader-subtitle">Por favor espera un momento...</p>
    </div>
  </div>

  <div class="loader-skeleton" aria-hidden="true">
    <div class="skeleton-row header"></div>
    <div class="skeleton-row" *ngFor="let i of [0, 1, 2, 3]"></div>
  </div>
</div>

<ng-template #elseBlock>
  <div class="divHome">
    <div class="header-container">
      <h1>Generación de Orden de Servicio</h1>
      <div class="location-container" *ngIf="location">
        <i-tabler name="map-pin"></i-tabler>
        <h1>{{ getLocation() }}</h1>
      </div>
    </div>

    <section class="file-selector-card">
      <div class="file-selector-header">
        <div>
          <h3>Escoge un File</h3>
          <p>Busca por número de File para cargar sus servicios.</p>
        </div>
      </div>

      <mat-form-field appearance="outline" class="file-selector-field">
        <mat-icon matPrefix class="file-selector-icon">search</mat-icon>
        <input
          type="text"
          placeholder="202XXXXXXZ"
          matInput
          [formControl]="fileControl"
          [matAutocomplete]="autoInsumo"
        />
        <mat-autocomplete
          #autoInsumo="matAutocomplete"
          [displayWith]="getOptionText"
          (optionSelected)="onSelectionChanged()"
        >
          <mat-option
            *ngFor="let option of filteredOptions | async"
            [value]="option"
          >
            <div class="file-option">
              <span class="file-option-number">{{ option.fileNumber }}</span>
              <span class="file-option-extension" *ngIf="option.fileExtend">
                {{ option.fileExtend }}
              </span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </section>

    <div *ngIf="showServices" class="filters-panel">
      <div class="scope-banner" role="note">
        <div class="scope-banner-copy">
          <span class="scope-banner-eyebrow">Alcance de la grilla</span>
          <p class="scope-banner-title">
            Solo se muestran servicios
            <span class="scope-type-pill">PERSONALDECAMPO</span>
          </p>
          <p class="scope-banner-subtitle" *ngIf="categoriasFiltradas?.length; else noCategories">
            Categorías disponibles en este file:
          </p>
          <ng-template #noCategories>
            <p class="scope-banner-subtitle">
              No hay categorías PERSONALDECAMPO para la ubicación seleccionada.
            </p>
          </ng-template>
        </div>
        <div class="scope-category-chips" *ngIf="categoriasFiltradas?.length">
          <span
            class="scope-category-chip"
            *ngFor="let categoria of categoriasFiltradas"
          >
            {{ categoria }}
          </span>
        </div>
      </div>

      <div class="divButtons">
        <mat-form-field appearance="outline" class="buttonFilter">
          <mat-label>CATEGORIA SERVICIO</mat-label>
          <input
            type="text"
            matInput
            placeholder="Escribe o elige una categoría"
            [formControl]="categoriaControl"
            [matAutocomplete]="autoCategoria"
            autocomplete="off"
            (input)="onFilterInputChange($event)"
          />
          <mat-autocomplete
            #autoCategoria="matAutocomplete"
            (optionSelected)="applyFilterSelect()"
          >
            <mat-option value="">Sin filtro</mat-option>
            <mat-option
              *ngFor="let categoria of filteredCategorias | async"
              [value]="categoria"
            >
              {{ categoria }}
            </mat-option>
          </mat-autocomplete>
          <div class="field-hint">Sin filtro si no eliges nada</div>
        </mat-form-field>

        <mat-form-field appearance="outline" class="buttonFilter">
          <mat-label>SERVICIO</mat-label>
          <input
            type="text"
            matInput
            placeholder="Escribe o elige un servicio"
            [formControl]="servicioControl"
            [matAutocomplete]="autoServicio"
            autocomplete="off"
            (input)="onFilterInputChange($event)"
          />
          <mat-autocomplete
            #autoServicio="matAutocomplete"
            (optionSelected)="applyFilterSelect()"
          >
            <mat-option value="">Sin filtro</mat-option>
            <mat-option
              *ngFor="let service of filteredServices | async"
              [value]="service"
            >
              {{ service }}
            </mat-option>
          </mat-autocomplete>
          <div class="field-hint">Busca por nombre de servicio</div>
        </mat-form-field>

        <mat-form-field appearance="outline" class="buttonFilter">
          <mat-label>ESTADO OS</mat-label>
          <input
            type="text"
            matInput
            placeholder="Escribe o elige un estado"
            [formControl]="estadoOsControl"
            [matAutocomplete]="autoEstadoOS"
            autocomplete="off"
            (input)="onFilterInputChange($event)"
          />
          <mat-autocomplete
            #autoEstadoOS="matAutocomplete"
            (optionSelected)="applyFilterSelect()"
          >
            <mat-option value="">Sin filtro</mat-option>
            <mat-option
              *ngFor="let optionSelect of filteredEstadosOS | async"
              [value]="optionSelect"
            >
              {{ optionSelect }}
            </mat-option>
          </mat-autocomplete>
          <div class="field-hint">Filtra por estado de orden</div>
        </mat-form-field>

        <mat-form-field appearance="outline" class="buttonFilter">
          <mat-label>NUM OS</mat-label>
          <input
            type="text"
            matInput
            placeholder="Escribe o elige un número"
            [formControl]="numOsControl"
            [matAutocomplete]="autoNumOS"
            autocomplete="off"
            (input)="onFilterInputChange($event)"
          />
          <mat-autocomplete
            #autoNumOS="matAutocomplete"
            (optionSelected)="applyFilterSelect()"
          >
            <mat-option value="">Sin filtro</mat-option>
            <mat-option
              *ngFor="let numOS of filteredNumOS | async"
              [value]="numOS"
            >
              {{ numOS }}
            </mat-option>
          </mat-autocomplete>
          <div class="field-hint">Números ya generados</div>
        </mat-form-field>

        <mat-form-field appearance="outline" class="buttonFilter">
          <mat-label>NOMBRE PROVEEDOR</mat-label>
          <input
            type="text"
            matInput
            placeholder="Escribe o elige un proveedor"
            [formControl]="proveedorControl"
            [matAutocomplete]="autoProveedor"
            autocomplete="off"
            (input)="onFilterInputChange($event)"
          />
          <mat-autocomplete
            #autoProveedor="matAutocomplete"
            (optionSelected)="applyFilterSelect()"
          >
            <mat-option value="">Sin filtro</mat-option>
            <mat-option
              *ngFor="let proveedor of filteredProveedores | async"
              [value]="proveedor"
            >
              {{ proveedor }}
            </mat-option>
          </mat-autocomplete>
          <div class="field-hint">Filtra por proveedor asociado</div>
        </mat-form-field>
      </div>

      <div class="search-row">
        <mat-form-field appearance="outline" class="divInputSearch">
          <input
            matInput
            [(ngModel)]="filterValue"
            (ngModelChange)="applyFilter()"
            placeholder="Buscar en la tabla"
          />
        </mat-form-field>
      </div>

      <div
        class="secctionButtonOS"
        *ngIf="personalCampoDataSource.data.length > 0"
      >
        <div>
          <button
            mat-raised-button
            [ngClass]="{
              buttonActive: estadoBtnMasivo > 0 && !isCreateOrderBusy,
              buttonDisable: estadoBtnMasivo === 0 || isCreateOrderBusy
            }"
            [disabled]="estadoBtnMasivo === 0 || isCreateOrderBusy"
            (click)="sendReservaOS()"
          >
            Generar OS
          </button>
        </div>
        <div style="height: 50%; height: 40px !important">
          <p
            *ngIf="estadoBtnMasivo === 0 && messageButtonOS"
            style="color: red; font-size: 0.6rem"
          >
            <i>* Seleccione los servicos que desea reservar Orden de Servico</i>
          </p>
        </div>
      </div>

      <div
        class="example-container mat-elevation-z8"
        *ngIf="personalCampoDataSource"
      >
        <mat-table [dataSource]="personalCampoDataSource" matSort>
          <ng-container matColumnDef="Check">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? toggleAllRows() : null"
                [checked]="isAllSelected()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                [checked]="row.checked"
                [disabled]="hasServiceOrder(row)"
                [ngClass]="{
                  'disabled-checkbox': hasServiceOrder(row)
                }"
                (change)="updateCheck(row)"
              >
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceDay">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.serviceDay }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              {{ row.day }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="fecha">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.fecha }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              {{
                serviceDate(row)
                  ? (serviceDate(row) | date: 'dd/MM/yyyy')
                  : '-'
              }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="categoriaServicio">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.categoriaServicio }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              {{ row.categoriaServicio || '-' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nombreServicio">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.nombreServicio }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              {{ row.nombreServicio || '-' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nombre">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.nombre }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              {{ row.providerSnapshot?.nombre || '-' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="moneda">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.moneda }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              {{ row.moneda || '-' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="pax">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.pax }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              {{ row.paxQuantity ?? 0 }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="costo">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.costo }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              <div class="icon-edit">
                {{ row.total != null ? ceil(row.total) : "-" }}
                <button
                  mat-icon-button
                  type="button"
                  class="btn-icon-inline"
                  matTooltip="Editar monto"
                  *ngIf="canEditAmount(row, isSSFF)"
                  (click)="openDialogEditTarifa(row)"
                >
                  <i-tabler name="pencil" class="icon-20"></i-tabler>
                </button>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="orderNumber">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.orderNumber }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              {{ row.order?.displayCode || row.order?.orderNumber || '-' }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="orderStatus">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle dobleHeader"
            >
              {{ headers.orderStatus }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle dobleHeader">
              <span
                *ngIf="row.order?.orderStatus; else noAventuraOrderStatus"
                class="os-status"
                [attr.data-os-status]="row.order.orderStatus.toUpperCase()"
              >
                {{ row.order.orderStatus }}
              </span>
              <ng-template #noAventuraOrderStatus>-</ng-template>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="freezeDeadlineAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle">
              {{ headers.freezeDeadlineAt }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              {{
                row.order?.freezeDeadlineAt
                  ? (row.order.freezeDeadlineAt | customDate | date: "dd/MM/yyyy")
                  : "-"
              }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="scheduledPaymentDate">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.scheduledPaymentDate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              <div class="icon-edit">
                {{
                  row.order?.scheduledPaymentDate
                    ? (row.order?.scheduledPaymentDate
                      | customDate
                      | date: 'dd/MM/yyyy')
                    : '-'
                }}
                <button
                  mat-icon-button
                  *ngIf="
                    (isSSFF || !(row.ssffproduct && row.productId)) &&
                    isOrderEditable(row)
                  "
                  (click)="openDialogEditFechaPagoProgramada(row)"
                >
                  <i-tabler
                    name="calendar-repeat"
                    style="width: 20px; height: 20px; font-size: 20px"
                  ></i-tabler>
                </button>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="reservationNumber">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.reservationNumber }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              <div class="icon-edit">
                {{ row.order?.reservationNumber || '-' }}
                <span *ngIf="row.total && isOrderEditable(row)">
                  <i-tabler
                    name="pencil"
                    style="width: 24px; height: 24px; font-size: 24px"
                    (click)="
                      openDialogNumReservaManual(
                        row.tipoServicio,
                        row.nombreServicio,
                        row.idItinerary,
                        row.id,
                        row.providerSnapshot?.nombre,
                        true,
                        row
                      )
                    "
                  ></i-tabler>
                </span>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="reservationStatus">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle dobleHeader"
            >
              {{ headers.reservationStatus }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle dobleHeader">
              <div class="icon-edit">
                {{ row.order?.reservationStatus || '-' }}
                <span *ngIf="row.total && isOrderEditable(row)">
                  <i-tabler
                    name="calendar-event"
                    style="width: 24px; height: 24px; font-size: 24px"
                    (click)="
                      openDialogReservaManual(
                        row.tipoServicio,
                        row.nombreServicio,
                        row.idItinerary,
                        row.id,
                        row.providerSnapshot?.nombre,
                        false,
                        row
                      )
                    "
                  ></i-tabler>
                </span>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="verPDF">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="headerStyle"
            >
              {{ headers.verPDF }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="bodyStyle">
              <app-services-os-actions
                [row]="row"
                [model]="model"
                (modelChanged)="applyFilterSelect()"
              ></app-services-os-actions>
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="fileDisplayedColumns"
          ></mat-header-row>
          <mat-row *matRowDef="let row; columns: fileDisplayedColumns">
          </mat-row>
        </mat-table>
      </div>
      <mat-paginator
        [pageSize]="5"
        [pageSizeOptions]="[5, 10, 25, 100]"
      ></mat-paginator>
    </div>
  </div>
</ng-template>
